'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hyphenateStyleName = require('./hyphenateStyleName');

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

var _removeStyle = require('./removeStyle');

var _removeStyle2 = _interopRequireDefault(_removeStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (node, property, value) {
  var css = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      new Error('value is undefined');
    }
    (props = {})[property] = value;
  }

  for (var key in props) {
    if (Object.prototype.hasOwnProperty.call(props, key)) {
      !props[key] && props[key] !== 0 ? (0, _removeStyle2.default)(node, (0, _hyphenateStyleName2.default)(key)) : css += (0, _hyphenateStyleName2.default)(key) + ':' + props[key] + ';';
    }
  }

  node.style.cssText += ';' + css;
};